export const StripToAlphanumeric = function (string) {
  return string.replace(/[^a-z ]/gi, '');
};
export const StripSpecialChars = function (string) {
  // eslint-disable-next-line no-useless-escape
  return string.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
};
export const StripWhitespace = function (string) {
  // eslint-disable-next-line no-useless-escape
  return string.replace(/\s/g, '');
};

/** capitalize first letter */
export const Capitalize = (s) => {
  return String(s[0]).toUpperCase() + String(s).slice(1);
};